import { atom } from 'jotai';
import { defaultMetricConfig } from '@src/globalStore/limitationStore';

export const defaultFlowConfig = {
  flowConfigMeta: {},
  flowMetricCategoryMeta: {},
  flowMetricCategoryKeys: {},
  flowMetricCategoryOrder: [],
};

export const categoryMetaAtom = atom({});
export const categoryMetaKeysAtom = atom({});
export const categoryMetaOrderAtom = atom<string[]>([]);
export const flowDataAtom = atom(defaultFlowConfig);
export const configAtom = atom(defaultMetricConfig);
export const tempKPIAtom = atom<any>([]);
export const allSelectedPresentAtom = atom<boolean>(false);
